<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <div>{{ formContent }}</div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item v-for="(problem, index) in form.problemList" :key="index" :label="problem.title">
        <div v-if="problem.type === 1">
          <a-radio-group v-model="problem.answerResult">
            <a-radio
              v-for="(option, index) in problem.optionList"
              :key="index"
              :value="option.id"
              :style="{ pointerEvents: 'none', opacity: 1 }"
            >
              {{ option.content }}
            </a-radio>
          </a-radio-group>
        </div>
        <div v-if="problem.type === 2">
          <a-checkbox-group v-model="problem.answerResult">
            <a-checkbox
              v-for="(option, index) in problem.optionList"
              :key="index"
              :value="option.id"
              :style="{ pointerEvents: 'none', opacity: 1 }"
            >
              {{ option.content }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
        <div v-if="problem.type === 3">
          <a-input type="textarea" v-model="problem.answerResult" :style="{ pointerEvents: 'none', opacity: 1 }"/>
        </div>
      </a-form-model-item>
<!--      <div class="bottom-control">-->
<!--        <a-space>-->
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
<!--          <a-button type="dashed" @click="cancel">-->
<!--            取消-->
<!--          </a-button>-->
<!--        </a-space>-->
<!--      </div>-->
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSurveyAnswers, addSurveyAnswers, updateSurveyAnswers } from '@/api/biz/surveyAnswers'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      formContent: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        description: null,

        imgUrls: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        description: null,
        imgUrls: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 详情按钮操作 */
    handleQuery (record) {
      this.form = record
      this.open = true
      this.formTitle = record.title
      this.formContent = record.content
      if (record.problemList) {
        record.problemList.forEach(problem => {
          if (problem.type === 2) {
            problem.answerResult = problem.answerResult.split(',')
          }
        })
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSurveyAnswers({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSurveyAnswers(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSurveyAnswers(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
